import { ProcurementFilterTeamModel } from "./ProcurementFilterTeam.model";

export class ProcurementFilterTeam extends ProcurementFilterTeamModel {
    // Add custom methods here
}
